var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('button',{attrs:{"className":"google_login_wrap"},on:{"click":function($event){return _vm.googleSignIn()}}},[_c('img',{attrs:{"src":require("@/assets/image/main/google.png")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }